import React, { Component } from "react";
import ReactPlayer from "react-player";
import Videopath1 from "../../videos/Packaging.mp4";

class PackVid extends Component {
  render() {
    return <ReactPlayer url={Videopath1} controls pip width="100%" />;
  }
}

export default PackVid;
